// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1-oR6","question":"Question_question__UEqoM","description":"Question_description__2x7sp"};